export const SIZE = {
  U0: '0rem', // 0px
  U025: '0.0625rem', // 1px
  U05: '0.125rem', // 2px
  U1: '0.25rem', // 4px
  U2: '0.5rem', // 8px
  U3: '0.75rem', // 12px
  U4: '1rem', // 16px
  U4_5: '1.125rem', // 18px
  U5: '1.25rem', // 20px
  U6: '1.5rem', // 24px
  U7: '1.75rem', // 28px
  U8: '2rem', // 32px
  U9: '2.25rem', // 36px
  U10: '2.5rem', // 40px
  U11: '2.75rem', // 44px
  U12: '3rem', // 48px
  U13: '3.25rem', // 52px
  U14: '3.5rem', // 56px
  U15: '3.75rem', // 60px
  U16: '4rem', // 64px
  U17: '4.25rem', // 68px
  U18: '4.5rem', // 72px
  U19: '4.75rem', // 76px
  U20: '5rem', // 80px
  U21: '5.25rem', // 84px
  U22: '5.5rem', // 88px
  U23: '5.75rem', // 92px
  U24: '6rem', // 96px
  U25: '6.25rem', // 100px
  U26: '6.5rem', // 104px
  U27: '6.75rem', // 108px
  U28: '7rem', // 112px
  U29: '7.25rem', // 116px
  U30: '7.5rem', // 120px
  U31: '7.75rem', // 124px
  U32: '8rem', // 128px
  U33: '8.25rem', // 132px
  U34: '8.5rem', // 136px
  U35: '8.75rem', // 140px
  U36: '9rem', // 144px
  U37: '9.25rem', // 148px
  U38: '9.5rem', // 152px
  U39: '9.75rem', // 156px
  U40: '10rem', // 160px
  Round: '62.4375rem', // 999px

  Xs: '0.5rem', // U2
  Sm: '0.75rem', // U3
  Md: '1rem', // U4
  Lg: '1.5rem', // U6
  Xl: '2rem', // U8
  Xl2: '3rem', // U12
  Xl3: '4rem', // U16
} as const;

export const SPACING = {
  // Horizontal spacing
  'X.None': SIZE.U0,
  'X.Xs': SIZE.U05,
  'X.Sm': SIZE.U1,
  'X.Md': SIZE.U2,
  'X.Lg': SIZE.U4,
  'X.Xl': SIZE.U6,
  'X.Xl2': SIZE.U8,
  'X.Xl3': SIZE.U10,
  'X.Xl4': SIZE.U12,
  'X.Xl5': SIZE.U14,
  'X.Xl6': SIZE.U16,
  // Vertical spacing
  'Y.None': SIZE.U0,
  'Y.Xs': SIZE.U05,
  'Y.Sm': SIZE.U1,
  'Y.Md': SIZE.U2,
  'Y.Lg': SIZE.U4,
  'Y.Xl': SIZE.U6,
  'Y.Xl2': SIZE.U8,
  'Y.Xl3': SIZE.U10,
  'Y.Xl4': SIZE.U12,
  'Y.Xl5': SIZE.U14,
  'Y.Xl6': SIZE.U16,
} as const;

export const RADIUS = {
  None: SIZE.U0,
  Sm: SIZE.U1,
  Md: SIZE.U2,
  Lg: SIZE.U4,
  Round: SIZE.Round,
} as const;

export const BORDER = {
  Sm: SIZE.U025,
  Md: SIZE.U05,
  Lg: SIZE.U1,
} as const;
